import { storage } from "../../connection";
import moment from "moment";

import { getDownloadURL, ref, uploadBytes } from "@firebase/storage";
import { chantApi } from "../../../../utils/chantApi";
const imagePath = "tickets/images/";

// Read all the contents
export async function fbGetTicketDetails(ticketId, groupId) {
  const res = await chantApi.get(
    `${import.meta.env.VITE_GCP_BASE_URL}/tickets/getSingleGroupTicket?groupId=${groupId}&ticketId=${ticketId}`,
  );
  return res;
}

export function uploadTicketImage(file, id, oldImageName) {
  return new Promise((resolve, reject) => {
    const storageRef = ref(storage);
    const fileName = oldImageName ? oldImageName : moment().unix();

    const folderRef = ref(storageRef, `${imagePath}${id}/${fileName}`);
    uploadBytes(folderRef, file)
      .then(async (snapshot) => {
        const downloadUrl = await getDownloadURL(snapshot.ref);
        resolve({ downloadUrl, fullPath: snapshot.metadata.fullPath });
      })
      .catch(reject);
  });
}

export const fetchAllGroupTickets = async (groupId, options = {}) => {
  const {
    limit = null,
    offset = 0,
    orderDirection = "desc",
    eventType,
  } = options;

  const params = new URLSearchParams({ groupId, orderDirection, offset });

  if (eventType) params.append("eventType", eventType);
  if (limit) params.append("limit", limit);

  const response = await chantApi.get(
    `${import.meta.env.VITE_GCP_BASE_URL}/tickets/getAllGroupTickets?${params.toString()}`,
  );

  return response.data;
};

// export const fetchAllGroupTickets = async (groupId, options = {}) => {
//   const {
//     limit: limitCount = null,
//     offset = 0,
//     orderDirection = "desc",
//     eventType,
//   } = options;

//   if (!eventType) {
//     throw new Error("Event type is required");
//   }

//   if (groupId === "" || groupId === "string") {
//     throw new Error("Group Id should not be empty");
//   }

//   try {
//     const ticketsCollection = collection(db, "tickets", groupId, "ticket");

//     const today = new Date();
//     today.setHours(0, 0, 0, 0);
//     const startOfTodayTimestamp = Math.floor(today.getTime() / 1000);

//     let filterConditions = [
//       where("matchTicket", "==", {}),
//       where("groupTicket.eventDate", "!=", null),
//     ];

//     if (eventType === "current") {
//       filterConditions.push(
//         where("groupTicket.eventDate", ">=", startOfTodayTimestamp),
//         where("groupTicket.publishStatus", "in", ["live", "saved"])
//       );
//     } else if (eventType === "past") {
//       filterConditions.push(
//         or(
//           where("groupTicket.eventDate", "<", startOfTodayTimestamp),
//           where("groupTicket.publishStatus", "==", "archived")
//         )
//       );
//     }

//     const queryConstraints = [
//       and(...filterConditions),
//       orderBy("groupTicket.eventDate", orderDirection),
//     ];

//     if (limitCount && offset > 0) {
//       queryConstraints.push(limit(offset + limitCount));
//     } else if (limitCount) {
//       queryConstraints.push(limit(limitCount));
//     }

//     const firestoreQuery = query(ticketsCollection, ...queryConstraints);
//     const snapshot = await getDocs(firestoreQuery);

//     let countFilterConditions = [
//       where("matchTicket", "==", {}),
//       where("groupTicket.eventDate", "!=", null),
//     ];

//     if (eventType === "current") {
//       countFilterConditions.push(
//         where("groupTicket.eventDate", ">=", startOfTodayTimestamp),
//         where("groupTicket.publishStatus", "in", ["live", "saved"])
//       );
//     } else if (eventType === "past") {
//       countFilterConditions.push(
//         or(
//           where("groupTicket.eventDate", "<", startOfTodayTimestamp),
//           where("groupTicket.publishStatus", "==", "archived")
//         )
//       );
//     }

//     const countQuery = query(ticketsCollection, and(...countFilterConditions));
//     const countSnapshot = await getCountFromServer(countQuery);
//     const totalCount = countSnapshot.data().count;

//     let responseData = [];
//     if (!snapshot.empty) {
//       const allDocs = snapshot.docs.map((doc) => ({
//         data: doc.data(),
//         id: doc.id,
//       }));

//       if (offset > 0 && limitCount) {
//         responseData = allDocs.slice(offset, offset + limitCount);
//       } else if (offset > 0) {
//         responseData = allDocs.slice(offset);
//       } else {
//         responseData = allDocs;
//       }
//     }

//     const hasMore = limitCount && offset + limitCount < totalCount;

//     return {
//       status: true,
//       body: responseData,
//       message: "Success",
//       pagination: {
//         total: totalCount,
//         offset: offset,
//         limit: limitCount,
//         hasMore: hasMore,
//         returned: responseData.length,
//       },
//     };
//   } catch (err) {
//     console.error(err);
//     throw new Error(err.toString());
//   }
// };
